import {AbstractControl, ValidationErrors} from '@angular/forms';
/**
 * @param {?} c
 * @return {?}
 */
export function consistOfObjects(c: AbstractControl): null | ValidationErrors {
  if (c.value) {
    const /** @type {?} */ objectConstructor = {}.constructor;
    const /** @type {?} */ arrayConstructor = [].constructor;

    const /** @type {?} */ error = {
      consistOfObjects: {
        numOfItemsThatAreNoObject: 0,
        message: 'Signature segments don\'t contain of objects'
      }
    };

    if (c.value.constructor !== arrayConstructor) {
      return null;
    }

    const /** @type {?} */ countOfNonObjects =
      c.value.reduce((nonObjCount, line) => {
        if (line.constructor !== arrayConstructor) {
          return false;
        }
        nonObjCount += line.filter((i) => {
          // filter non objects
          return i.constructor !== objectConstructor;
        }).length;
      }, 0);

    // return error if a non object is contained
    if (countOfNonObjects > 0) {
      error.consistOfObjects.numOfItemsThatAreNoObject = countOfNonObjects;
      return error;
    }
    return null;
  }
  return null;
}
